/**
 * Check if a route is a Back Office route
 * Back Office routes require authentication and are not public pages
 * @param route The route to check
 * @returns true if the route is a Back Office route
 */
export function isBackOfficeRoute(route) {
    return route.meta.requiresAuth === true && route.meta.isPublicPage !== true;
}
